import { EXPRESS_API } from 'configs/api/expressApi';
import { errorToast } from 'lib/components/toasts/error';
import { successToast } from 'lib/components/toasts/success';
import { useMutation } from 'react-query';
import { SERVICE } from './types';

interface ServiceSubscribeResponse {
  success: boolean;
  message: string;
}

interface ServiceSubscriptionData {
  eventType: string;
  service: SERVICE;
}

export const fetchServiceSubscription = async ({
  eventType,
  service,
}: ServiceSubscriptionData): Promise<ServiceSubscribeResponse> => {
  const response = await EXPRESS_API.post(`/${service}/subscriptions`, {
    eventType: eventType,
  });
  return response.data;
};

export const useServicesSubsciptionMutation = (service: SERVICE) => {
  return useMutation(
    (data: Omit<ServiceSubscriptionData, 'service'>) =>
      fetchServiceSubscription({ service, ...data }),
    {
      onSuccess: () => {
        successToast({ title: 'Successfully subscribed to service.' });
      },
      onError: () => {
        errorToast({
          title: 'Failed to subscribe to service. Please try again later.',
        });
      },
    }
  );
};
